import React, { useState, useEffect, useRef } from 'react';
const CopyToolTip = (props) => {
    const [copied, setCopied] = useState(false);
    
    const ref = useRef(null);
    
    useEffect(() => {
        const handleClickOutside = () => {
            props.setShowCopyToolTip(false);
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });

    if (props.showCopyToolTip) {
        setTimeout(() => {
            props.setShowCopyToolTip(false);
        }, 2000);
    }

    if(!props.showCopyToolTip)
        return null;

    return (<div className="copy-tooltip-wrapper">
        <div className="tips" dangerouslySetInnerHTML={{ __html: "Copied to clipboard" }}>
        </div>
    </div>);
}

export default CopyToolTip;